<template>
  <ContextButton>
    {{ $t("legal_text.context.move") }}
    <template #icon>
      <i-simple-line-icons-cursor-move class="inline-block h-6 w-6" />
    </template>
  </ContextButton>
</template>
